<div>
  <div class="d-flex gap-1 align-items-center">
    <!-- Label -->
    <label
      *ngIf="label"
      class="labelText labelIdle labelConfig"
      [for]="name"
      [class.labelActive]="isCheckboxOnFocus"
      [innerHTML]="label | safeHtml"
    ></label>
    @if (inputLabelTooltipText?.length) {
    <finxone-platform-tooltip
      [content]="inputLabelTooltipText"
      [textStyleClass]="tooltipTextStyleClass"
      [borderRadiusClass]="tooltipBorderRadiusClass"
    ></finxone-platform-tooltip>
    }
  </div>
  <div
    class="position-relative"
    [ngClass]="radioCheckboxOptionsLayout === 'horizontal' ? 'd-flex flex-wrap gap-3' : ''"
  >
    <ng-container *ngFor="let option of options">
      <div class="d-flex mb-2 gap-2">
        <input
          type="checkbox"
          class="checkboxInput cursor-pointer"
          [id]="name + option[optionValueKey]"
          [name]="name + option[optionValueKey]"
          [value]="option[optionValueKey]"
          [readonly]="readOnly"
          [disabled]="isDisabled"
          [checked]="control?.value?.includes(option[optionValueKey])"
          (change)="onCheckboxValueChange($event)"
          (blur)="onTouched(); isCheckboxOnFocus = false"
          (focus)="isCheckboxOnFocus = true"
        />

        <!-- Custom option template or default option -->
        <ng-container *ngIf="customCheckboxOptionTemplate; else defaultOptionTemplate">
          <ng-container
            [ngTemplateOutlet]="customCheckboxOptionTemplate"
            [ngTemplateOutletContext]="{
              $implicit: option
            }"
          ></ng-container>
        </ng-container>

        <ng-template #defaultOptionTemplate>
          <label
            [ngClass]="textStylingClass"
            [for]="name + option[optionValueKey]"
            [innerHTML]="renderedOptionLabels[option[optionValueKey]] | safeHtml"
          ></label>
        </ng-template>
      </div>
    </ng-container>
  </div>

  <!-- Error Handling -->
  <div *ngIf="showErrors && control?.invalid && control?.touched" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
      <small class="typog-xs text-error">
        {{ getErrorMessageBasedOnKey(error) }}
      </small>
      }
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control?.errors
        }
      }"
    ></ng-container>
  </div>

  <!-- Helper Text Template -->
  <ng-container *ngIf="helperText">
    <div [innerHTML]="helperText | safeHtml"></div>
  </ng-container>
</div>
